
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.933 10.091L4.754 7.912a1.067 1.067 0 10-1.508 1.509l4 4a1.067 1.067 0 001.508 0l4-4a1.067 1.067 0 00-1.508-1.509l-2.18 2.18V3.332a1.067 1.067 0 10-2.133 0v6.758z","fill":"#CF4655"}})])
          )
        }
      }
    